import { render, staticRenderFns } from "./RoundModalAxios.vue?vue&type=template&id=3533c0d6&"
import script from "./RoundModalAxios.vue?vue&type=script&lang=ts&"
export * from "./RoundModalAxios.vue?vue&type=script&lang=ts&"
import style0 from "./RoundModalAxios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports